<div>

    <!-- TOP ACTIONS -->
    <div class="pb-2">
      <div class="mt-2 d-flex pe-3 justify-content-end gap-2">
        <button
          class="btn btn-primary-dark btn-sm text-xxs shadow"
          data-bs-toggle="modal"
          data-bs-target="#upload_additional_documents_modal"
        >
          Add documents
        </button>

        <button
          v-if="has_unverified_documents"
          class="btn btn-primary-dark btn-sm text-xxs shadow"
          data-bs-toggle="modal"
          data-bs-target="#request_information"
          @click="open_request_modal"
        >
          Request Information
        </button>
      </div>
    </div>

    <!-- MAIN CARD -->
    <div class="glassy-bg p-3 rounded-lg shadow-sm">
      <div v-if="table_safe_documents.length > 0" class="row">
        <!-- LEFT: DOCUMENT LIST -->
        <div class="col-md-5">
          <div
            v-for="(doc, index) in table_safe_documents"
            :key="index"
            class="document-card d-flex justify-content-between align-items-center p-3 mb-3 rounded-lg bg-white"
            :class="{ active: selected_document === doc }"

            @click="select_document(doc)"
          >
            <div class="d-flex align-items-start gap-3">

              <div class="file-icon">
                <i class="bi bi-file-earmark-text fs-4 text-primary-blue"></i>
              </div>

              <div>
                <div class="fw-semibold text-sm">
                  {{ doc.file_name }}
                </div>

                <div class="text-muted text-xxs mt-1">
                  {{ doc.section }} • {{ format_date(doc.submitted_on) }}
                </div>

                <span
                  class="badge mt-2 text-xs fw-semibold"
                  :class="doc.is_verified ? 'bg-success' : 'bg-warning text-dark'"
                >
                  {{ doc.is_verified ? 'Verified' : 'Pending Verification' }}
                </span>
              </div>
            </div>

            <i class="bi bi-eye text-muted fs-5"></i>
          </div>

        </div>

        <!-- RIGHT: PREVIEW PANEL -->
        <div class="col-md-7">
          <div class="preview-panel p-3 rounded-lg bg-white">
            <div v-if="selected_document">
              <h6 class="fw-bold mb-3">Document Preview</h6>
              <div class="preview-container mb-3">
                <iframe
                  v-if="selected_document.presigned_url"
                  :src="selected_document.presigned_url"
                  width="100%"
                  height="420"
                  class="rounded"
                ></iframe>
              </div>

              <div class="text-xs">
                <p><strong>Document : </strong> {{ selected_document.file_name }}</p>
                <p><strong>Section : </strong> {{ selected_document.section }}</p>
                <p>
                  <strong>Status : </strong>
                  <span :class="selected_document.is_verified ? 'text-success' : 'text-warning'">
                    {{ selected_document.is_verified ? 'Verified' : 'Pending Verification' }}
                  </span>
                </p>
              </div>

              <div class="mt-3 d-flex gap-2">
                <button
                  class="btn btn-primary-dark btn-sm text-xxs shadow"
                  @click="download_file(selected_document.presigned_url, selected_document.file_name)"
                >
                  Download
                </button>

                <button
                  v-if="!selected_document.is_verified"
                  class="btn btn-primary-dark btn-sm text-xxs shadow"
                  @click="verify_document(selected_document)"
                >
                  Verify
                </button>
              </div>
            </div>
            <div v-else class="text-muted text-center py-5">
              Select a document to preview
            </div>
          </div>
        </div>
      </div>
      <div v-else class="p-4 text-center text-muted">
        No documents available.
      </div>
    </div>

  </div>

<teleport to="body">
  <div class="modal fade" id="request_information" tabindex="-1" aria-labelledby="request_information_label"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="request_information_label">Request Information</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Current section's answered files -->
          <div v-if="answered_file_questions.length > 0" class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="text-xxs fw-bold mb-0">Files in current section:</p>
            </div>
            <div class="mt-3">
              <div v-for="question in answered_file_questions" :key="question.id" class="file-list-item">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-file-earmark me-2 text-primary"></i>
                    <div>
                      <div class="text-xxs">{{ question.question_text }}</div>
                    </div>
                  </div>
                  <input type="checkbox" :value="question.section_question_id"
                    :data-requested_field_text="question.question_text" class="form-check-input ms-3"
                    @change="toggle_requested_field($event, question)" />
                </div>
              </div>
            </div>
          </div>

          <div class="modal-form-group form-group mb-2 d-flex flex-column">
            <label for="request_info_note" class="modal-form-label form-label text-start text-xxs">Notes</label>
            <textarea v-model="request_info_note" id="request_info_note"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" rows="4">
          </textarea>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
            @click="request_information">Request</button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="upload_additional_documents_modal" tabindex="-1"
    aria-labelledby="upload_additional_documents_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 shadow-lg">
        <!-- Header -->
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
          <h5 class="modal-title text-white text-xs m-0" id="upload_additional_documents_modal_label">
            Upload additional documents
          </h5>
          <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-4">
          <form @submit.prevent="upload_additional_documents">
            <!-- Journal Attachments -->
            <div class="form-group mb-3">
              <div class="d-flex justify-content-end align-items-center mb-2">
                <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="add_attachment">
                  <i class="fas fa-plus"></i>
                </button>
              </div>

              <!-- Dynamic Attachments -->
              <div v-for="(attachment, index) in attachments" :key="index"
                class="border rounded p-3 mb-3 position-relative">
                <!-- Remove Button -->
                <button type="button"
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark position-absolute top-0 end-0 m-2"
                  @click="remove_attachment(index)">
                  <i class="bi bi-trash-fill"></i>
                </button>

                <!-- Document Name -->
                <div class="mb-2">
                  <label class="text-xxs fw-bold">Document Name</label>
                  <input type="text" v-model="attachment.document_name" class="form-control text-xs mt-1"
                    placeholder="e.g. Affidavit, Supporting Evidence" required />
                </div>

                <!-- Upload File -->
                <div>
                  <label class="text-xxs fw-bold">Upload File</label>
                  <input type="file" class="form-control text-xs mt-1" @change="handle_file_upload($event, index)"
                    accept=".pdf,.png,.jpg,.jpeg,.docx" required />
                  <small v-if="attachment.file" class="text-success text-xxs mt-1 d-block">
                    {{ attachment.file.name }}
                  </small>
                </div>
              </div>

              <!-- Empty State -->
              <p v-if="attachments.length === 0" class="text-muted text-xxs mt-2 mb-0 fst-italic">
                No attachments added yet. Click <b>+</b> to add your first file.
              </p>
            </div>



            <!-- Submit Button -->
            <div class="d-flex justify-content-end mt-3">
              <button type="submit" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                :disabled="is_uploading_documents">
                <span v-if="!is_uploading_documents">Save documents</span>
                <span v-else>Saving...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</teleport>